// extracted by mini-css-extract-plugin
export var header = "HtmlHeader-module--header--4ce36";
export var plainHeader = "HtmlHeader-module--plainHeader--00b30";